import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const PartyMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  
  const [accList, setAccList] = useState([]);
  const [allPartyList, setAllPartyList] = useState([]);
  
  const [entryList, setEntryList] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState('');

  const [partyNameList, setPartyNameList] = useState([]);
  const [accNameList, setAccNameList] = useState([]);

  const [trAmount, setTrAmount] = useState('');

  const today = new Date().toISOString().split("T")[0];
  const [entryDate, setEntryDate] = useState(today);

  const accOptions = accNameList.map(acc => ({
    value: acc,
    label: acc,
  }));

  const partyOptions = partyNameList.map(party => ({
    value: party,
    label: party,
  }));

  const fetchAccountList = async () => { 
          try {
            const response = await fetch(`${host_url}/cash_entry`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
                'userid': localStorage.getItem('userid'),
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: '',
                sdate: startDate,
                edate: endDate,
              }),
            });

            if (response.status === 401) {
              localStorage.clear();
              alert('Your account has been disabled.');
              window.location.href = "/";
              return;
            }

            const data = await response.json();
            setEntryList(data);
            const uniqueAccNames = [ ...new Set(data.map(item => item.scb_acc_name))
                                    ].sort((a, b) => a.localeCompare(b));
            setAccNameList(uniqueAccNames);
            const uniquePartyNames = [...new Set(data.map(item => item.scb_party_name))].sort((a, b) => a.localeCompare(b));
            setPartyNameList(uniquePartyNames);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }    
      }; 
  
  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      document.title = "Cash Entry";
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible ) {
            setModalVisible(false);
            setAddModalVisible(false);
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible]);

    useEffect(() => { 
     fetchAccountList(); 
    }, [host_url, store]); // Cash-Bank Ledger

    useEffect(() => { 
      
        const accountDetail = {
            acc_type: 'CashBank_Party',
        };
        const fetchAccountDetail = async () => { 
          try {
            const response = await fetch(`${host_url}/account_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: accountDetail,
              }),
            });            
            const data = await response.json();
            setAccList(data);              
           
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
       fetchAccountDetail();  
    }, [addmodalVisible]); // Cash Bank Account List

    
    useEffect(() => { 
        if (selectedEntry.scb_party_acc_type === null || selectedEntry.scb_party_acc_type === undefined) return;
        const accountDetail = {
            acc_type: selectedEntry.scb_party_acc_type,
        };
        const fetchPartyAccountList = async () => { 
          try {
            const response = await fetch(`${host_url}/account_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: accountDetail,
              }),
            });            
            const data = await response.json();
            setAllPartyList(data.filter(item => item.sacc_id !== Number(selectedEntry.scb_acc_id)));       
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
        fetchPartyAccountList(); 
    }, [selectedEntry.scb_party_acc_type, selectedEntry.scb_acc_id]); // Party Account List
    

    const sdate = new Date();
    sdate.setMonth(sdate.getMonth());
    sdate.setDate(1);
    const ThreeMonthAgo = sdate.toISOString().split("T")[0];

    const edate = new Date();
    edate.setMonth(edate.getMonth());
    edate.setDate(edate.getDate());
    const currentDate = edate.toISOString().split("T")[0];

    const [startDate, setStartDate] = useState(ThreeMonthAgo);
    const [endDate, setEndDate] = useState(currentDate);
    const [accNameFilter, setAccNameFilter] = useState('');
    const [partyNameFilter, setPartyNameFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');

    const filteredEntryList = entryList.filter(party =>{
      const cbentryDate = new Date(party.scb_date); 
      const start = startDate ? new Date(startDate) : null;
      if (start) {
        start.setDate(start.getDate() -1 ); // Subtract 1 day
      }
      const end = endDate ? new Date(endDate) : null;
      if (end) {
        end.setDate(end.getDate() + 1); // ✅ +1 day
      }
      
      return (
        party.scb_acc_name.toLowerCase().includes(accNameFilter.toLowerCase()) &&
        party.scb_tr_type.toLowerCase().includes(typeFilter.toLowerCase()) &&
        party.scb_party_name.toLowerCase().includes(partyNameFilter.toLowerCase()) &&
        (!start || cbentryDate >= start) && 
        (!end || cbentryDate <= end)
      );
    });


   

    const totalCount = filteredEntryList.length;
    const totalReceive = filteredEntryList.reduce((sum, party) => sum + Number(party.scb_receipt), 0);
    const totalPayment = filteredEntryList.reduce((sum, party) => sum + Number(party.scb_payment), 0);
   
    const handleEntryDetail = (row) => {
      setModalVisible(true);
      setSelectedEntry(row);
      setTrAmount(row.scb_tr_type === 'Receipt' ? row.scb_receipt : row.scb_payment);
    };

    // Functions for handling the different actions
    const handleAddEntry = async () => {
      setAddModalVisible(false);
      const updatedEntry = {
          ...selectedEntry,  
              scb_receipt: selectedEntry.scb_tr_type === 'Receipt' ? trAmount : 0,
              scb_payment: selectedEntry.scb_tr_type === 'Payment' ? trAmount : 0,
              scb_date: today,
              scb_remark: selectedEntry.scb_remark || '',
      };
      try {
        const response = await fetch(`${host_url}/cash_entry`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'entry_insert',
            store: store,
            suId : '',
            accDetail: updatedEntry,
            sdate: startDate,
            edate: endDate,
          }),
        });
        const data = await response.json();
        setEntryList(data);

      } catch (error) {
        console.error('Error fetching cities:', error);
      }

    };

    const handleUpdateEntry = async () => {
      setModalVisible(false);
      const updatedEntry = {
          ...selectedEntry,  
              scb_receipt: selectedEntry.scb_tr_type === 'Receipt' ? trAmount : 0,
              scb_payment: selectedEntry.scb_tr_type === 'Payment' ? trAmount : 0,
              scb_date: today,
      };
      try {
        const response = await fetch(`${host_url}/cash_entry`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'entry_update',
            store: store,
            accDetail: updatedEntry,
            sdate: startDate,
            edate: endDate,
          }),
        });
        const data = await response.json();
        setEntryList(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleDeleteEntry = async () => {
      const userConfirmed = window.confirm('Are you sure you want to delete this Entry?');
      if (userConfirmed) {
        setModalVisible(false);
        const updatedEntry = {
            ...selectedEntry,  
                scb_receipt: selectedEntry.scb_tr_type === 'Receipt' ? trAmount : 0,
                scb_payment: selectedEntry.scb_tr_type === 'Payment' ? trAmount : 0,
                scb_date: today,
        };
        try {
          const response = await fetch(`${host_url}/cash_entry`, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              type: 'entry_delete',
              store: store,
              accDetail: updatedEntry,
              sdate: startDate,
              edate: endDate,
            }),
          });
          const data = await response.json();
          if (data.message) {
              alert(data.message); 
          } else {
              setEntryList(data);
          }
          
        } catch (error) {
          console.error('Error fetching cities:', error);
        }
      }  
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Cash-Bank Register</b>
              <div onClick={() => setAddModalVisible(true)}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th><input type="date" className='search-input no-icon' style={{ textAlign: 'center' }} value={startDate} onChange={(e) => setStartDate(e.target.value)}  onBlur={fetchAccountList}/></th>
                <th colSpan='2'>Cash-Bank A/c.</th>
                <th>Type</th>
                <th colSpan='2'>Party A/c.</th>
                <th>Receipt</th>
                <th>Payment</th>
              </tr>
              <tr >
                <th><input type="date" className='search-input no-icon' style={{ textAlign: 'center' }} value={endDate} onChange={(e) => setEndDate(e.target.value)} onBlur={fetchAccountList}/></th>
                <th colSpan='2'>
                    <select
                      className="search-input"
                      style={{fontSize: '14px' }}
                      value={accNameFilter}
                      onChange={(e) => setAccNameFilter(e.target.value)}
                      autoFocus
                    >
                      <option value="">All Party</option>
                      {accNameList.map((acc, index) => (
                        <option key={index} value={acc}>
                          {acc}
                        </option>
                      ))}
                    </select>

                </th>
                <th>
                    <select
                      className="search-input"
                      style={{fontSize: '14px' }}
                      value={typeFilter}
                      onChange={(e) => setTypeFilter(e.target.value)}
                    >
                      <option value="">All Type</option>
                      <option value="Receipt">Receipt</option>
                      <option value="Payment">Payment</option>
                    </select>
                </th>
                <th colSpan='2'>
                    <select
                      className="search-input"
                      style={{fontSize: '14px' }}
                      value={partyNameFilter}
                      onChange={(e) => setPartyNameFilter(e.target.value)}
                    >
                      <option value="">All Party</option>
                      {partyNameList.map((party, index) => (
                          <option key={index} value={party}>
                            {party}
                          </option>
                      ))}
                    </select>
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredEntryList.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px' }} onClick={row.scb_party_type === 'Account' ? () => handleEntryDetail(row) : undefined}>
                      <td >{new Date(row.scb_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.scb_acc_name}</span></td>
                      <td className="cell-left" >{row.scb_tr_type}</td>  
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.scb_party_name}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.scb_receipt}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.scb_payment}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left"><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th colSpan='5' className="cell-left"></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalReceive}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalPayment}</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Account Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >User Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Cash/Bank A/c.</td>
                        <td>
                          <select
                            value={selectedEntry.scb_acc_id}
                            onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_acc_id: e.target.value })}
                          >
                            <option key='' value=''>Select Party</option>
                            {accList.map((accList, index) => (
                                <option key={index} value={accList.sacc_id}>
                                  {accList.sacc_name}
                                </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Transaction</td>
                        <td>
                            <select
                              value={selectedEntry.scb_tr_type}
                              onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_tr_type: e.target.value })}
                            >
                              <option value="">Select Types</option>
                              <option value="Receipt">Receipt</option>
                              <option value="Payment">Payment</option>
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td className="cell-left">Party Type</td>
                        <td>
                            <select
                              value={selectedEntry.scb_party_acc_type}
                              onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_party_acc_type: e.target.value })}
                            >
                              <option value="">Select Types</option>
                              <option value="Pur_Party">Pur_Party</option>
                              <option value="Salary_Party">Salary_Party</option>
                              <option value="Exp_Party">Exp_Party</option>
                              <option value="CashBank_Party">CashBank_Party</option>
                              {/* Add more roles as needed */}
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td className="cell-left">Party A/c.</td>
                        <td>
                          <select
                            value={selectedEntry.scb_party_id}
                              onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_party_id: e.target.value })}
                          >
                            <option key='' value=''>Select Party</option>
                            {allPartyList.map((accList, index) => (
                                <option key={index} value={accList.sacc_id}>
                                  {accList.sacc_name}
                                </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Amount</td>
                        <td><input type="text" maxLength="10" value={trAmount} onChange={(e) => setTrAmount(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}/></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Remark</td>
                        <td><input type="text" value={selectedEntry.scb_remark} onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_remark: e.target.value })}/></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleDeleteEntry}>
                      Delete
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleUpdateEntry}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          {/* Modal for Add New Entry */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New Entry</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Cash/Bank A/c.</td>
                        <td>
                          <select
                            value={selectedEntry.scb_acc_id}
                            onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_acc_id: e.target.value })}
                          >
                            <option key='' value=''>Select Acc</option>
                            {accList.map((accList, index) => (
                                <option key={index} value={accList.sacc_id}>
                                  {accList.sacc_name} ( {accList.sacc_balance} )
                                </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Transaction</td>
                        <td>
                            <select
                              value={selectedEntry.scb_tr_type}
                              onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_tr_type: e.target.value })}
                            >
                              <option value="">Select Types</option>
                              <option value="Receipt">Receipt</option>
                              <option value="Payment">Payment</option>
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td className="cell-left">Party Type</td>
                        <td>
                            <select
                              value={selectedEntry.scb_party_acc_type}
                              onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_party_acc_type: e.target.value })}
                            >
                              <option value="">Select Types</option>
                              <option value="Pur_Party">Pur_Party</option>
                              <option value="Salary_Party">Salary_Party</option>
                              <option value="Exp_Party">Exp_Party</option>
                              <option value="CashBank_Party">CashBank_Party</option>
                              {/* Add more roles as needed */}
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td className="cell-left">Party A/c.</td>
                        <td>
                          <select
                            value={selectedEntry.scb_party_id}
                              onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_party_id: e.target.value })}
                          >
                            <option key='' value=''>Select Party</option>
                            {allPartyList.map((accList, index) => (
                                <option key={index} value={accList.sacc_id}>
                                  {accList.sacc_name} ( {accList.sacc_balance} )
                                </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Amount</td>
                        <td><input type="text" maxLength="10" value={trAmount} onChange={(e) => setTrAmount(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}/></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Remark</td>
                        <td><input type="text" value={selectedEntry.scb_remark} onChange={(e) => setSelectedEntry({ ...selectedEntry, scb_remark: e.target.value })}/></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddEntry}>
                      Add New
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default PartyMaster;
